import { useState, useEffect } from 'react';

/**
 * Custom hook for animating counter values
 * @param {Object} targetValues - Object with target counter values
 * @param {boolean} inView - Whether the component is in view
 * @param {number} duration - Animation duration in milliseconds (default: 2000)
 * @returns {Object} Current counter values
 */
export const useCounterAnimation = (targetValues, inView, duration = 2000) => {
  const [counters, setCounters] = useState(
    Object.keys(targetValues).reduce((acc, key) => {
      acc[key] = 0;
      return acc;
    }, {})
  );

  useEffect(() => {
    if (inView) {
      const animateCounters = () => {
        const steps = 60;
        const stepDuration = duration / steps;

        let currentStep = 0;
        const interval = setInterval(() => {
          currentStep++;
          const progress = currentStep / steps;

          const newCounters = {};
          Object.keys(targetValues).forEach(key => {
            newCounters[key] = Math.floor(targetValues[key] * progress);
          });

          setCounters(newCounters);

          if (currentStep >= steps) {
            clearInterval(interval);
            setCounters(targetValues);
          }
        }, stepDuration);

        return () => clearInterval(interval);
      };

      const cleanup = animateCounters();
      return cleanup;
    }
  }, [inView, targetValues, duration]);

  return counters;
};

export default useCounterAnimation;
